<div class="tfr-auth-page">
  <div class="tfr-auth-card">

    <h1 class="text-[20px] font-bold leading-snug tracking-tight text-center mb-1 text-midnight-indigo">
      Acepta los términos para continuar
    </h1>
    <p class="text-[13px] text-center leading-relaxed mb-7 text-steel-gray">
      Detectamos que entraste con Google sin haber aceptado los documentos
      legales. Antes de seguir usando la plataforma necesitamos tu confirmación.
    </p>

    <div class="tfr-auth-legal mb-4">
      <p class="tfr-kicker">Documentos</p>
      <ul class="flex flex-col gap-1 mb-3 list-none">
        <li><a routerLink="/terminos" target="_blank" rel="noopener noreferrer" class="tfr-link-muted text-[12px]">Términos de Servicio</a></li>
        <li><a routerLink="/privacidad" target="_blank" rel="noopener noreferrer" class="tfr-link-muted text-[12px]">Política de Privacidad</a></li>
        <li><a routerLink="/terminos-propietarios" target="_blank" rel="noopener noreferrer" class="tfr-link-muted text-[12px]">Acuerdo de Comisiones</a></li>
      </ul>
      <label class="flex items-start gap-2 cursor-pointer select-none">
        <input type="checkbox" [checked]="accepted()" (change)="toggle()"
          class="mt-0.5 h-4 w-4 shrink-0 accent-midnight-indigo cursor-pointer" />
        <span class="text-[12px] leading-snug text-slate-blue">
          He leído y acepto los documentos enlazados arriba.
        </span>
      </label>
    </div>

    @if (error()) {
      <p class="text-[12px] text-red-500 text-center mb-3">{{ error() }}</p>
    }

    <button type="button" (click)="finalize()" [disabled]="!accepted() || submitting()" class="tfr-btn-sm w-full">
      @if (submitting()) { Guardando&hellip; } @else { Finalizar registro }
    </button>

    <button type="button" (click)="cancel()" class="w-full mt-3 py-2 text-[12px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo">
      Cancelar y cerrar sesión
    </button>
  </div>
</div>
